import React, { ComponentType } from "react"
import { reportError } from "utils/ErrorReporting"

const createErrorBoundary = (component: ComponentType) =>
  class ErrorBoundary extends React.Component<{}, { hasError: boolean }> {
    state = {
      hasError: false
    }

    static getDerivedStateFromError(error) {
      reportError(error)
      return { hasError: true }
    }

    unsetError = () => {
      this.setState({
        hasError: false
      })
    }

    render() {
      if (this.state.hasError) {
        //@ts-ignore
        return React.createElement(component, { unsetError: this.unsetError })
      }

      return this.props.children
    }
  }

export { createErrorBoundary }
